import React from 'react';
import { useCheckStatSigFeatureGate } from '../bootstrap/StatSigInitialization';
import { STATSIG_FEATURE_GATES } from '../bootstrap/statsigFeatureGates';
import type { Site } from '../hooks/useSite';

export default function UninstallRouteAccess({
	Component,
	LoginComponent,
	hasError,
	site,
}: {
	Component: React.ComponentType<{ site?: Site; userAccount?: undefined }>;
	LoginComponent?: React.ComponentType<{ hasError: boolean }>;
	hasError: boolean;
	site?: Site;
}): React.JSX.Element {
	const checkGate = useCheckStatSigFeatureGate();
	let allowAnonymousAccess = false;
	try {
		allowAnonymousAccess = checkGate(STATSIG_FEATURE_GATES.UNINSTALLATION_ANALYTICS);
	} catch {
		// Failed initialization must not relax the existing authentication requirement.
	}

	if (allowAnonymousAccess) {
		return <Component site={site} userAccount={undefined} />;
	}
	return LoginComponent ? <LoginComponent hasError={hasError} /> : <></>;
}
